module.exports = __webpack_public_path__ + "static/media/bg_checkup.bcbdc78e.png";